const types = {
	//Get Template name
	GET_EXTERNAL_AUDIT_START: "GET_EXTERNAL_AUDIT_START",
	GET_EXTERNAL_AUDIT_SUCCESS: "GET_EXTERNAL_AUDIT_SUCCESS",
	GET_EXTERNAL_AUDIT_ERROR: "GET_EXTERNAL_AUDIT_ERROR",
	GET_EXTERNAL_AUDIT_RESET: "GET_EXTERNAL_AUDIT_RESET",

	//Create Template name
	CREATE_EXTERNAL_AUDIT_START: "CREATE_EXTERNAL_AUDIT_START",
	CREATE_EXTERNAL_AUDIT_SUCCESS: "CREATE_EXTERNAL_AUDIT_SUCCESS",
	CREATE_EXTERNAL_AUDIT_ERROR: "CREATE_EXTERNAL_AUDIT_ERROR",
	CREATE_EXTERNAL_AUDIT_RESET: "CREATE_EXTERNAL_AUDIT_RESET",

	//delete Template name
	DELETE_EXTERNAL_AUDIT_START: "DELETE_EXTERNAL_AUDIT_START",
	DELETE_EXTERNAL_AUDIT_SUCCESS: "DELETE_EXTERNAL_AUDIT_SUCCESS",
	DELETE_EXTERNAL_AUDIT_ERROR: "DELETE_EXTERNAL_AUDIT_ERROR",
	DELETE_EXTERNAL_AUDIT_RESET: "DELETE_EXTERNAL_AUDIT_RESET",

	//update Template name
	UPDATE_EXTERNAL_AUDIT_START: "UPDATE_EXTERNAL_AUDIT_START",
	UPDATE_EXTERNAL_AUDIT_SUCCESS: "UPDATE_EXTERNAL_AUDIT_SUCCESS",
	UPDATE_EXTERNAL_AUDIT_ERROR: "UPDATE_EXTERNAL_AUDIT_ERROR",
	UPDATE_EXTERNAL_AUDIT_RESET: "UPDATE_EXTERNAL_AUDIT_RESET",

	//single item  name
	SINGLE_EXTERNAL_AUDIT_START: "SINGLE_EXTERNAL_AUDIT_START",
	SINGLE_EXTERNAL_AUDIT_SUCCESS: "SINGLE_EXTERNAL_AUDIT_SUCCESS",
	SINGLE_EXTERNAL_AUDIT_ERROR: "SINGLE_EXTERNAL_AUDIT_ERROR",
	SINGLE_EXTERNAL_AUDIT_RESET: "SINGLE_EXTERNAL_AUDIT_RESET",
};

export default types;
